import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Unlogged from './unlogged-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Unlogged {...validProps} />;
}
SvgComponent.iconName = 'unlogged-icon';

/**
 * @deprecated This is a legacy icon
 */
export const UnloggedIcon = svgIconWrapper(SvgComponent);
